import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import { MenuItem } from '@/models';
import { ui } from '@/constants';
import { getAllMenuItems, arrayToMap, isDefined } from '@/helpers';

@Component({
  name: 'CmgBagReconciliationModal',
})
export default class CmgBagReconciliationModal extends Vue {
  items: MenuItem[] = [];
  removingItems = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.bagReconciliation.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.bagReconciliation.args;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get isPickup(): boolean {
    return !!this.args && this.args.isPickup;
  }

  @Watch('visible')
  async onVisibleUpdated(visible: boolean) {
    if (!visible || !this.args) {
      return;
    }

    // Get items from the active menu that match the ids provided
    const menu = this.$appStore.state.menu.activeMenu;
    if (menu) {
      const allItems = arrayToMap(getAllMenuItems(menu, true, true), i => i.itemId);
      this.items = this.args.itemsIds.map(id => allItems[id]).filter(isDefined);
    }
  }

  close() {
    this.$services.ui.setModalVisibility('bagReconciliation', false);
    this.$services.ui.setModalVisibility('findAChipotle', false);
    this.$services.ui.setModalVisibility('deliveryAddress', false);
    
    const focusNearby = document.getElementsByClassName('address-details-close')[0] as HTMLElement;
    if (focusNearby) {
      focusNearby.focus();
    }
  }

  onClickClose() {
    if (this.args) {
      this.args.onCancel();
    }

    this.close();
  }

  async onClickRemoveItems() {
    this.removingItems = true;

    try {
      const order = this.$services.order.getCurrentOrder();
      if (!order || !this.args) {
        return;
      }

      await this.$services.order.removeItemsFromOrder(
        order,
        this.items.map(item => ({ id: item.itemId, name: item.itemName })),
      );

      this.removeUpsellItemsFromStore();
      
      const restaurant = await this.$services.restaurant.getRestaurantByNumber(this.args.restaurantId);
      await this.$services.restaurant.selectRestaurant(restaurant, this.isPickup);

      this.args.onRemoveItems();

      this.close();
    } finally {
      this.removingItems = false;
    }
  }

  private removeUpsellItemsFromStore(): void {
     const upsellMeal = this.$appStore.state.order.upsellMeal;

     this.items.forEach((item) => {
       upsellMeal?.drinks?.forEach((d, i) => d.menuItemId == item.itemId && upsellMeal.drinks?.splice(i, 1));
       upsellMeal?.sides?.forEach((s, i) => s.menuItemId == item.itemId && upsellMeal.drinks?.splice(i, 1));
     });
     
     if ((!upsellMeal?.drinks || upsellMeal.drinks.length == 0) && (!upsellMeal?.sides || upsellMeal.sides?.length == 0)) {
       this.$services.order.setUpsellMeal(null);
     }
  }
}
